<template>
    <section id="catalog-page-header">
        <div class="catalog-page-header w-100">
            <hero-box></hero-box>
        </div>
    </section>
</template>

<script>
import HeroBox from "../molecules/HeroBox.vue";

export default {
    name: 'CatalogPageHeader',
    components: {
        HeroBox,
    }
}
</script>